import { getQueryParameters, regionApi, regionRequest } from './regionApi';

export const regionUserHelperApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    /* ================================================== */
    /* Helper by account                                  */
    /* ================================================== */
    getHelperByAccount: build.query<any, Record<string, any>>({
      query: ({ account }) =>
        regionRequest(account?.region, 'instance/get_api_user_helper_info', {
          method: 'POST',
          body: getQueryParameters(account)
        }),

      providesTags: (_result, _error, arg) => [
        {
          type: 'Helper',
          id: arg?.account?.group_id || 0
        },
        { type: 'Helper' }
      ],

      transformResponse: (result, _meta, arg) =>
        getQueryParameters(arg?.account, {
          data: result
        })
    })

    /* ================================================== */
  }),

  overrideExisting: false
});

export const { useGetHelperByAccountQuery, useLazyGetHelperByAccountQuery } =
  regionUserHelperApi;
